import GlCategoryList from '@/pages/components/manage/category/GlCategoryList';
import FsCategoryList from "@/pages/components/manage/category/FsCategoryList";

export default {
  glList: GlCategoryList,
  fsList: FsCategoryList,
  recordRepresentation: 'code',
};
